import React from "react";
import styled, { withTheme } from "styled-components";
import {
  MdKeyboardArrowLeft as BackArrowIcon,
  MdKeyboardArrowRight as ForwardArrowIcon
} from "react-icons/md";

import ChapterView from "./ChapterView";
import { useChapter } from "../ChapterContainer";
import { useScriptureRouting } from "components/Bible/useScriptureRouting";

const StyledNavBox = styled.div`
  display: flex;
  flex: 1;
  padding: 1rem;
  max-width: 7rem;
`;

const NavButton = styled.div`
  position: relative;
  border-radius: 2px;
  text-align: center;
  cursor: pointer;
  color: #dcdcdc;
  height: 100%;
  transition: all 0.5s;

  &:hover {
    color: ${props => props.theme.computedPrimary};
  }
  svg {
    /* provide fallback for browsers who don't support sticky */
    position: relative;
    position: sticky;
    top: 50vh;
  }
`;

const ChapterDisplayFlex = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${props => props.theme.background};
  flex-direction: ${props =>
    props.theme.scriptDirection === "rtl" ? "row-reverse" : "row"};
`;

interface StandardChapterLayoutProps {
  platformType: string;
  setModeDefault: () => void;
  theme: any;
}

const StandardChapterLayout: React.FC<StandardChapterLayoutProps> = ({
  platformType,
  children,
  setModeDefault,
  theme
}) => {
  const { setChapter, bibleId, parallelBibleIds } = useScriptureRouting();
  const bibleIds = [bibleId, ...parallelBibleIds];
  const { getChapter } = useChapter();
  let prevChapterId = "";
  let nextChapterId = "";
  for (let bId of bibleIds) {
    const chapter = getChapter({ bibleId: bId });
    prevChapterId = chapter?.previous?.id || "";
    nextChapterId = chapter?.next?.id || "";
    if (prevChapterId || nextChapterId) break;
  }

  return (
    <ChapterDisplayFlex>
      <StyledNavBox>
        {prevChapterId && (
          <NavButton
            onClick={() => {
              setModeDefault();
              if (window) window.scrollTo(0, 0);
              return setChapter({
                chapterId: prevChapterId
              });
            }}
          >
            {theme.scriptDirection === "rtl" ? (
              <ForwardArrowIcon size={40} />
            ) : (
              <BackArrowIcon size={40} />
            )}
          </NavButton>
        )}
      </StyledNavBox>

      <div style={{ display: "flex", flex: "10" }}>
        <ChapterView platformType={platformType} />
      </div>

      <StyledNavBox>
        {nextChapterId && (
          <NavButton
            onClick={() => {
              setModeDefault();
              if (window) window.scrollTo(0, 0);
              return setChapter({
                chapterId: nextChapterId
              });
            }}
          >
            {theme.scriptDirection === "rtl" ? (
              <BackArrowIcon size={40} />
            ) : (
              <ForwardArrowIcon size={40} />
            )}
          </NavButton>
        )}
      </StyledNavBox>

      {children}
    </ChapterDisplayFlex>
  );
};

export default withTheme(StandardChapterLayout);
